<template>
    <div class="pt-5 pb-3 text-center">
        <div id="search-heading" class="text-center text-app py-5 fadeInUp">
            <h1>Love Music? Love Typing? We got you covered!</h1>
        </div>
        <div id="search-bar-container" class="fadeInUp">
            <div id="above-search-bar" class="text-muted mb-0" align="center">
                Type name of the song, artist etc.
                <div id="vertical-line" class="text-center mt-2"></div>
            </div>
            <div class="input-container mt-0">
                <SearchIcon size="30" class="search-icon"></SearchIcon>
                <XCircleIcon v-if="getShowClearIcon" size="30" class="cancel-icon" @click="eraseSongText()"></XCircleIcon>
                <input type="text" id="music-search-bar" placeholder="Never Gonna Give You Up Rick" class="shadow-lg"
                    @keyup.enter="sendSong()" v-model="songEntered" autofocus>
            </div>
        </div>  
    </div>
</template>

<script>
import {SearchIcon, XCircleIcon} from 'vue-feather-icons';

export default {
    name: 'Search',
    components: {
        SearchIcon,
        XCircleIcon
    },
    data: function() {
        return {
            searchInputId: "music-search-bar",
            songEntered: "",
        }
    },
    methods: {
        sendSong() {
            // Send the song to the parent component.
            let tempSongStr = this.songEntered.replace(/[ ]{2,}/g, " ").replace(/^ | $/g, "");
            if (tempSongStr == "") {
                // Add a border around the input and clear the text.
                this.songEntered = "";
                document.getElementById(this.searchInputId).classList.add("error");
                setTimeout(() => {
                    document.getElementById(this.searchInputId).classList.remove("error");
                }, 30000);
            }
            this.$emit("searchClicked", tempSongStr);
            document.getElementById(this.searchInputId).blur();
        },
        eraseSongText() {
            // Clear the text.
            this.songEntered = "";
        }
    },
    computed: {
        getShowClearIcon() {
            return this.songEntered.length;
        }
    }
}
</script>

<style lang="scss">
    #above-search-bar {
        #vertical-line {
            height: 20px;
            width:0;
            border-left: 2px solid #BDBDBD;

        }
    }
    .input-container {
        .search-icon {
            position: absolute;
            color: #BDBDBD;
            bottom: 15px;
            margin-left: 10px;
        }
        .cancel-icon {
            position: absolute;
            color: #BDBDBD;
            right: 26%;
            bottom: 15px;
        }
        input {
            width: 50%;
            height: 60px;
            border: none;
            padding: 15px 15px;
            font-size: 22px;
            border-radius: 7px;
            padding-left: 50px;
            color: lighten(#121212, 5);

            &:focus {
                outline: none;
                border: none;
            }

        }

        .error {
            border: 1px solid #E91E63 !important;
        }
    }

    @media only screen and (max-width: 850px) {
        #search-heading {
            padding-left: 15px;
            padding-right: 15px;
        }

        .input-container {
            input {
                width: 65%;
            }
        }
    }

    @media only screen and (max-width: 468px) {
        #search-heading h1 {
            font-size: 30px;
        }

        .input-container {
            .cancel-icon {
                position: absolute;
                color: #BDBDBD;
                right: 10%;
            }

            input {
                width: 90%;
            }
        }
    }
</style>